import React, { memo } from 'react'

export default memo(function Recover() {
  return <div>Recover</div>
})
